'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/badge/style/css.js
// module id = 251
// module chunks = 0